import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { SharedComponents } from "../../../components/shared.module";
import { Actions } from "../../../core/enums/automation.enum";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import {
  selectAutomationError,
  selectLoading,
} from "../../../core/ngrx/selectors/automation.selectors";
import { projectCardMoreDetails } from "../../../core/tree/script-generator";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-automation-project-overview",
  standalone: true,
  imports: [...SharedComponents, CommonModule],
  templateUrl: "./automation-project-overview.component.html",
  styleUrl: "./automation-project-overview.component.scss",
})
export class AutomationProjectOverviewComponent
  extends BaseLayoutComponent
  implements OnInit
{
  loading: boolean = false;
  scriptCards: any;
  private modalService = inject(NgbModal);
  projectId: any;
  automationProjectID!: string;
  loading$!: Observable<boolean>;
  error$!: Observable<string | null>;

  ngOnInit(): void {
    this.scriptCards = projectCardMoreDetails;
    console.log(this.dataStore.activeNode);
    this.loading$ = this.store.select(selectLoading);
    this.error$ = this.store.select(selectAutomationError);

    this.projectId = this.dataStore?.data?.id;
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectID = id;
    });
  }

  onActionFireEvents(MouseEvent: any, type: any, cardEvent: any) {
    console.log(MouseEvent, type, cardEvent);
    this.projectService.setAutomationCardType(type);
    switch (type) {
      case Actions.APPLICATION_CREATE:
        this.projectService.setAutomationCardType("applications");
        this.store.dispatch(
          AutomationActions.loadApplications({
            projectId: this.projectId,
            automationProjectId: this.automationProjectID,
          })
        );
        break;
      case Actions.SCRIPT_GROUP:
        this.projectService.setAutomationCardType("Script_Group_Card");
        this.store.dispatch(
          AutomationActions.loadScriptGroup({
            projectId: this.projectId,
            automationProjectId: this.automationProjectID,
          })
        );
        break;
      case Actions.REUSABLE_COMPONENT:
        this.projectService.setAutomationCardType("reusable_component");
        this.store.dispatch(
          AutomationActions.loadReusableComponent({
            projectId: this.projectId,
            automationProjectId: this.automationProjectID,
          })
        );
        break;
      case Actions.API_SERVICES:
        this.projectService.setAutomationCardType("api-service-view");
        this.store.dispatch(
          AutomationActions.loadService({
            projectId: this.projectId,
            automationProjectId: this.automationProjectID,
          })
        );
        break;
      default:
        break;
    }
  }
}
